import {Component} from '@angular/core';

import {ViewManagerService} from "src/app/services/view-manager.service";
import {SessionManagerService} from "../../services/session-manager.service";

@Component({
  selector: 'admin-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class AdminHeaderComponent {

  constructor(
    private viewManager: ViewManagerService,
    private sessionManager: SessionManagerService
  ) {
  }

  isLoggedIn() {
    return this.sessionManager.isLoggedIn
  }

  getSession() {
    return this.sessionManager.session
  }

  getCurrentDateTime() {
    return new Date().toUTCString()
  }

  messages() {
    return this.viewManager.messages
  }
}
